export default __webpack_public_path__ + "static/media/male_short_thick.0c4bb454.png";